import {Navigate} from "react-router-dom";
import {useContext} from "react";
import AuthContext from "../../context/AuthContext";
import PasswordChangeTab from "./PasswordChangeTab";
import Logo from "../../assets/images/BX-LOGO.svg";
import Loader from "../../components/Loader";


function ForcePasswordChangePage() {
    const {user, isUserLoading} = useContext(AuthContext);

    if (isUserLoading || user === null) {
        return <div className="d-flex justify-content-center mt-5"><Loader size="default" /></div>;
    }

    if (!user?.must_change_password) {
        return <Navigate to="/" replace />;
    }

    return (
        <div className="account-pages mt-5 mb-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-xl-7">
                        <div className="card">
                            <div className="card-body p-4">
                                <div className="text-center w-75 m-auto">
                                    <span>
                                        <img
                                            src={Logo}
                                            width="73"
                                            height="56"
                                            alt="BlackX"
                                        />
                                    </span>
                                    <h4 className="mt-3">Change your password</h4>
                                    <p className="text-muted mb-4">
                                        This is a temporary password issued during onboarding. Set a new password to continue.
                                    </p>
                                </div>
                                <PasswordChangeTab redirectOnSuccess="/" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default ForcePasswordChangePage;
